
// DynamicPackageApi.ts
import apiClient from '@skygroup/shared/API/apiClient';
import endpoints from '@skygroup/shared/API/endpoints';


export const fetchPageData = async (secret: string, pageType?: string) => {
  if (!secret) {
    throw new Error('secret (path) is required');
  }

  const url = `${endpoints.DYNAMIC_PAGES.LOAD_FOR_B2C}?path=${secret}${pageType ? `&page_type=${pageType}` : ''}`;
  const res = await apiClient.get(url);

  // If backend uses a wrapper { status: 'error', data: { message } }
  // treat that as an error to allow react-query to handle it:
  if (res?.data?.status === 'error') {
    const messageText = res?.data?.data?.message || 'Error fetching dynamic page';
    throw new Error(messageText);
  }

  // Normalise payload: prefer res.data.data (common pattern), otherwise res.data
  const payload = res?.data?.data.page ?? res?.data.page;

  // If no pageConfig present, treat it as an error as well
  if (!payload || !payload.pageConfig) {
    throw new Error('Page data is missing or malformed');
  }

  return payload;
};




// export const fetchPageData = (secret: string): Promise<any> => {
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       if (secret === 'valid-secret') {
//         resolve(    {
//       "modules": [],
//             "pageConfig": {
//                 "id": 1,
//                 "seo": {
//                     "title": null,
//                     "desc": null
//                 },
//                 modules: ["DynamicPageBanner"],
//                 "name": "New Page",
//                 "path": "newPromTest",
//                 "is_active": 1,
//                 "page_type": "promotion",
//                 "user_privacy": "all",
//                 "website_privacy": "private",
//                 "layout": "default",
//                 "date_created": "2025-09-20 09:20:48",
//                 "date_modified": null
//             }
//     });
//       } else {
//         reject(new Error('Invalid secret'));
//       }
//     }, 1000); // Simulate 1 second delay
//   });
// };